import { render, staticRenderFns } from "./ModuleFeature.vue?vue&type=template&id=52b7fd50&scoped=true&"
import script from "./ModuleFeature.vue?vue&type=script&lang=js&"
export * from "./ModuleFeature.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52b7fd50",
  null
  
)

export default component.exports